import { Link } from "react-router-dom";
import { ScrollText, ShieldCheck, Gift } from "lucide-react";
import { useApp } from "../context/AppContext";
import { isKidsHost, mainHref } from "../lib/hosts";
import { SECURITY } from "../data/security";
import { TRIAL_TERMS } from "../data/trialTerms";

export function SiteFooter() {
  const { t, lang } = useApp();
  return (
    <footer data-testid="site-footer" className="mt-auto w-full border-t border-slate-200/70 bg-white/60 backdrop-blur-sm">
      <div className="max-w-6xl mx-auto px-4 py-4 flex flex-wrap items-center justify-between gap-2 text-xs text-slate-500">
      <span>© {new Date().getFullYear()} Ahdaf · {t("siteRights")}{isKidsHost() && <> · <a href={mainHref("/")} data-testid="footer-schools-link" className="font-semibold text-slate-600 hover:text-[#0038EB] underline-offset-4 hover:underline">{t("footerSchools")}</a></>}</span>
      <span className="inline-flex flex-wrap items-center gap-4">
        <Link to="/terms" data-testid="footer-terms-link" className="inline-flex items-center gap-1.5 font-semibold text-slate-600 hover:text-[#0038EB] underline-offset-4 hover:underline"><ScrollText size={14} /> {t("termsAndConditions")}</Link>
        {!isKidsHost() && <Link to="/trial-terms" data-testid="footer-trial-terms-link" className="inline-flex items-center gap-1.5 font-semibold text-slate-600 hover:text-[#0038EB] underline-offset-4 hover:underline"><Gift size={14} /> {(TRIAL_TERMS[lang] || TRIAL_TERMS.en).title}</Link>}
        {!isKidsHost() && <Link to="/security" data-testid="footer-security-link" className="inline-flex items-center gap-1.5 font-semibold text-slate-600 hover:text-[#0038EB] underline-offset-4 hover:underline"><ShieldCheck size={14} /> {SECURITY[lang]?.title || SECURITY.en.title}</Link>}
      </span>
      </div>
    </footer>
  );
}
